/* SLIDE-UP ON SCROLL */
(function () {
  function initHiddenSlideUp() {
    const elements = document.querySelectorAll(
      'img, h1, h2, h3, h4, h5, h6, p, .blog-post-item'
    );

    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.15,
      rootMargin: '0px 0px -100px 0px'
    });

    elements.forEach(el => {
      if (el.closest('header, footer, .header, .site-header, .sticky, .drawer, .modal, .header-logo__image')) return;
      observer.observe(el);
    });

    document.querySelectorAll('accordion-custom details').forEach(details => {
      details.addEventListener('toggle', () => {
        if (details.open) {
          const innerEls = details.querySelectorAll(
            'img, h1, h2, h3, h4, h5, h6, p, .blog-post-item'
          );

          innerEls.forEach(el => {
            el.classList.add('is-visible');
          });
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initHiddenSlideUp);
})();



/* Preloader */
(function () {
  const preloader = document.getElementById('site-preloader');
  if (!preloader) return;

  if (sessionStorage.getItem('preloaderShown')) {
    preloader.remove();
    return;
  }

  sessionStorage.setItem('preloaderShown', 'true');

  const durationSeconds = parseFloat(preloader.dataset.duration || 2);
  const totalDuration = durationSeconds * 1000;

  setTimeout(function () {
    preloader.style.opacity = '0';
    preloader.style.transition = 'opacity 0.4s ease';

    setTimeout(function () {
      preloader.remove();
    }, 400);
  }, totalDuration);
})();


